new Vue({
    el:'.celebration',
    data(){
        return{
            // 加载完成
            loadFlag:false,
            // 发送验证码标识
            sendFlag:false,
            loginFlag:false,
            likesFlag:false,
            formFlag:false,
            popup:false,
            postPopup:false,
            likesPopup:false,
            showtipPopup:false,
            loginPopup:false,
            diyPopup: false,
            isSend:false,
            isLogin:false,
            sendText:'Send code',
            findText:'',
            user:{
                id:-1,
                name:'',
                email:'',
                code:'',
                country:'Country',
                isForm:'false',
                isShow:'false',
                postText:'',
                postImg:''
            },
            //自定义
            likesArr2:{
                num1:0,
                num2:0,
                num3:0
            },
            submitFlag:false,
            popup1:false,
            select_flag1:0,
            countryArr:[],
            targetTime: new Date('2025-12-31 23:59:59').getTime(),
            countdown: {
                days: "00",
                hours: "00",
                minutes: "00",
                seconds: "00"
            },
            // diy
            isSaving: false,
            lastX: 0,
            lastY: 0,
            ctx: null,
            // upload
            uploadImg:'',
            imagePosition: { x: 0, y: 0 }, // 图片的位置
            startDragPosition: { x: 0, y: 0 }, // 拖拽开始的位置
            isDragging: false, // 是否正在拖拽
            scale: 1, // 当前缩放比例
            minScale: 1, // 最小缩放比例
            maxScale: 5, // 最大缩放比例
            lastTouchDistance: 0, // 双指缩放时记录两指的初始距离
            isMouseInside: false, // 标志鼠标是否在容器内
            uploadFlag:false,
            allArr:[],
            hoverIndex:null,
            hoverIndex1:null,
            hoverIndex2:true,
            likesArr:[],
            sharePost:[],
            showArr: [],     // 展示数据
            pageSize: 20,    // 每次加载的数量
            currentIndex: 0  // 当前加载到的位置
        }
    },
    computed: {
        hasMore() {
          return this.currentIndex < this.allArr.length;
        },
        //进度条相关
        visibleBlocks() {
            const MAX = 300;
            var TOTAL = 40;
            if(window.innerWidth<750){
                TOTAL = 15;
            }
            const len = this.allArr.length;
            
            if (len >= MAX) return TOTAL;
            
            // 平均分配可见块数
            const ratio = len / MAX;
            return Math.floor(TOTAL * ratio);
        },
        visibleMove() {
            const MAX = 300;
            var TOTAL = 75;
            if(window.innerWidth<750){
                TOTAL = 17.5;
            }
            const len = this.allArr.length;
            
            if (len >= MAX) return TOTAL;
            
            // 平均分配
            const ratio = len / MAX;
            return Math.floor(TOTAL * ratio);
        }
    },
    methods:{
        // 功能类-------------------------------------------------
        postsLikes(){
            if(!this.isLogin) return;
            if(this.user.email != 'ivydeng@oxva.com') return;
            //if(!this.getCookie('6th_test_cookie')) return;
            this.popup = this.likesPopup = true;
        },
        async submitLikes(){
            if(!this.isLogin) return;
            if(this.user.email != 'ivydeng@oxva.com') return;
            //if(!this.getCookie('6th_test_cookie')) return;

            if(this.likesFlag) return; //避免重复提交
            
            this.likesFlag = true
            let params=new URLSearchParams();
            params.append('info',JSON.stringify(this.likesArr2));
            let res = await axios.post('https://service.oxvatech.cn/anniversary/likes2',params);
            this.likesFlag = false
            if(res.data.status==200 || res.data.status==201){
                this.popup = this.likesPopup = false
                showMessage('Submission successful','success')
            }else{ 
                let errorMessages = {
                    500:'Server error, please contact customer service',
                };
                showMessage(errorMessages[res.data.status] || 'Unknown error', 'error');
            }
        },
        async uploadForm(){
            if(!this.uploadImg){
                showMessage('Please upload the image first.','error')
                return;
            }
            if(!this.user.postText){
                showMessage('Please enter your content first.','error')
                return;
            }
            if(this.user.postText.length > 2000) {
                showMessage('Oops, there are too many words.','error')
                return;
            }
            
            //避免重复提交
            showMessage('Uploading, please wait...','success')
            if(this.formFlag) return;
            this.formFlag = true
            
            //截图
            const canvas = await html2canvas(this.$refs.canvasContainer, {
                backgroundColor: null,
                useCORS: true,
                allowTaint: false
            });
            
            //Canvas 转 Blob（再转 File）
            const blob = await new Promise((resolve, reject) => {
                canvas.toBlob((b) => (b ? resolve(b) : reject(new Error('toBlob error'))), 'image/jpeg', 1);
            });
            const file = new File([blob], `your_moment_with_OXVA.jpeg`, { type: 'image/jpeg' });
            
            //上传文件
            const formData = new FormData();
            formData.append("files", file);
            let imgRes=await axios.post('https://service.oxvatech.cn/activity/upload',formData,{headers: {
                'Content-Type': 'multipart/form-data'
            }});
            
            if(!imgRes.status==200){
                return showMessage('Server error, please contact customer service','error')
            }
            
            //提交
            var params=new URLSearchParams();
            params.append('info',JSON.stringify({postImg:imgRes.data.files[0].path,postText:this.user.postText}));
            let res = await axios.post('https://service.oxvatech.cn/anniversary/upload',params,{
                headers: { Authorization: `${this.user.token}`}
            });
            if(res.data.status == 200){
                //提交成功
                showMessage('Upload successful, awaiting review...','success')
                this.user.isForm = 'true'
                
            }else{
                this.formFlag = false
                let errorMessages = {
                    201: 'You have already submitted it.',
                    500:' Server error, please contact customer service',
                };
                showMessage(errorMessages[res.data.status] || 'Unknown error', 'error');
            }
        },
        async myLikes(id){
            if(this.likesFlag) return; //避免重复提交
            if(this.likesArr.includes(id)) return; //避免重复点赞
            
            this.likesFlag = true
            var index = this.allArr.findIndex(item => item.id === id);
            if (index !== -1) {
                this.allArr[index].likes += 1;
            }
            if(id==this.user.id){
                this.user.likes += 1;
            }
            this.likesArr.push(id)
            // 替换式更新：一定会触发视图更新
            //this.likesArr = [...this.likesArr, id];
            
            let params=new URLSearchParams();
            params.append('info',id);
            let res = await axios.post('https://service.oxvatech.cn/anniversary/likes',params);
            this.likesFlag = false
            if(res.data.status==200 || res.data.status==201){
                showMessage('Liked','success')
            }else{ 
                let errorMessages = {
                    500:'Server error, please contact customer service',
                };
                showMessage(errorMessages[res.data.status] || 'Unknown error', 'error');
            }
        },
        // 发送邮箱验证
        async sendEmail(){
            if(this.user.email == ''){
                showMessage('Please enter your email','error')
                return;
            }
            // 邮箱正则表达式
            var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
            if(!emailReg.test(this.user.email)){
                showMessage('Email format error','error')
                return;
            }
            if(this.sendFlag){
                showMessage('Sent, please try again in one minute.','success')
                setTimeout(() => {
                    this.sendFlag = false
                    this.sendText = 'Send code'
                }, 1000*60);
                return;
            }
            this.sendText = 'Has sent'
            this.sendFlag = true
            var params=new URLSearchParams();
            params.append('info',JSON.stringify(this.user));
            let res = await axios.post('https://service.oxvatech.cn/anniversary/sendEmail',params);
            if(res.data.status == 200){
                this.isSend = true
                showMessage('Email has been sent, please check.','success')
            }else{
                showMessage('Server error, please contact customer service','error')
            }
        },
        //登录
        async loginActivity(){
            if(!this.isSend){
                showMessage('Please send the email verification code first','error')
                return;
            }
            if(!this.user.name || !this.user.email || this.user.country == 'Country' || !this.user.code){
                showMessage('Please fill in the information completely','error')
                return;
            }
            // 邮箱正则表达式
            var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
            if(!emailReg.test(this.user.email)){
                showMessage('Email format error','error')
                return;
            }
            //避免重复提交
            if(this.loginFlag) return;
            this.loginFlag = true
            var params=new URLSearchParams();
            params.append('info',JSON.stringify(this.user));
            let res = await axios.post('https://service.oxvatech.cn/anniversary/loginActivity',params);
            if(res.data.status == 200){
                this.setCookie('_oxva_6th',res.data.data,70)
                this.user.token = res.data.data
                showMessage('Registration successful! ','success')
                this.popup = this.loginPopup = false
                this.getInfo()
            }else{
                this.loginFlag = false
                let errorMessages = {
                    201: 'Email verification code error',
                    202: 'Username already exists',
                    500:' Server error, please contact customer service',
                };
                showMessage(errorMessages[res.data.status] || 'Unknown error', 'error');
            }
        },
        //用于登录后刷新页面时获取用户信息
        async getInfo(){
            let res = await axios.post('https://service.oxvatech.cn/anniversary/getInfo', {}, {
                headers: { Authorization: `${this.user.token}`}
            });
            if(res.data.status == 200){
                if(res.data.data.length>0){
                    this.isLogin = true
                    this.user = res.data.data[0]
                    
                    if(JSON.parse(this.user.isForm)){
                        //提前加载图片
                        var that = this
                        const preloadImages = () => {
                            var img = new Image();
                            img.src = that.user.postImg;
                        };
                        preloadImages()
                    }
                    
                    // if(this.user.name == ''){}
                    
                }else{
                    this.isLogin = false
                }
            }else{
                showMessage('server error','error')
            }
        },
        async getCountry(){
            let res = await axios.get('https://service.oxvatech.cn/public/getAllCountry')
            if(res.status == 200){
                this.countryArr = res.data.data
            }
        },
        async getPosts(){
            let res = await axios.get('https://service.oxvatech.cn/anniversary/getPosts')
            if(res.status == 200){
                //console.log(res.data)
                // 假设两个数组结构相同，且每个元素都有唯一 id
                const idsToRemove = new Set(res.data.data.arr1.map(item => item.id));

                // 过滤 arr2 中与 arr1 重复的
                const arr2Filtered = res.data.data.arr2.filter(item => !idsToRemove.has(item.id));

                // 合并
                const mergedArr = [...res.data.data.arr1, ...arr2Filtered];

                // 保存
                this.allArr = mergedArr.filter(item => item.id !== this.user.id);

                this.loadMore()

                //通过url查看帖子
                let href = window.location.href
                if(href.indexOf('?postId') !== -1 ){
                    let query = href.substring(href.indexOf('?') + 8);
                    var index = this.allArr.findIndex(item => item.id == query);
                    if (index !== -1) {
                        this.sharePost = this.allArr[index]
                        this.popup = this.postPopup=true
                    }else if(index === -1 && this.user.id == query){
                        if(!JSON.parse(this.user.isShow)){
                            this.popup = this.showtipPopup=true
                        }else{
                            this.sharePost = this.user
                            this.popup = this.postPopup=true
                        }
                    }
                }
                
            }
        },
        endTips(){
            showMessage('The event has ended, thank you for your participation.','success')
        },
        loadMore(){
            // 从 allArr 中截取接下来 20 条数据
            const nextData = this.allArr.slice(this.currentIndex, this.currentIndex + this.pageSize);
            this.showArr = this.showArr.concat(nextData);
            this.currentIndex += this.pageSize;
        },
        // 控件类-------------------------------------------------
        // 开始拖动
        startDrag(event) {
            event.preventDefault();
            
            const startX = event.type === "mousedown" ? event.clientX : event.touches[0].clientX;
            const startY = event.type === "mousedown" ? event.clientY : event.touches[0].clientY;
            
            this.startDragPosition = { x: startX, y: startY };
            this.isDragging = true;
            
            window.addEventListener("mousemove", this.drag);
            window.addEventListener("mouseup", this.stopDrag);
            window.addEventListener("touchmove", this.drag);
            window.addEventListener("touchend", this.stopDrag);
        },
        // 拖动
        drag(event) {
            if (!this.isDragging) return;
            
            const currentX = event.type === "mousemove" ? event.clientX : event.touches[0].clientX;
            const currentY = event.type === "mousemove" ? event.clientY : event.touches[0].clientY;
            
            const deltaX = currentX - this.startDragPosition.x;
            const deltaY = currentY - this.startDragPosition.y;
            
            this.startDragPosition = { x: currentX, y: currentY };
            
            let newX = this.imagePosition.x + deltaX;
            let newY = this.imagePosition.y + deltaY;
            
            this.imagePosition = { x: newX, y: newY };
        },
        // 停止拖动
        stopDrag() {
            this.isDragging = false;
            window.removeEventListener("mousemove", this.drag);
            window.removeEventListener("mouseup", this.stopDrag);
            window.removeEventListener("touchmove", this.drag);
            window.removeEventListener("touchend", this.stopDrag);
        },
        // 鼠标滚轮缩放
        handleWheel(event) {
            if (!this.isMouseInside) return;
            if (this.uploadImg =='') return; // 仅在鼠标移入容器且上传了图片时触发
            event.preventDefault();
            event.stopPropagation();
            const scaleChange = event.deltaY > 0 ? -0.1 : 0.1;
            this.updateScale(this.scale + scaleChange, event.clientX, event.clientY);
        },
        // 双指缩放
        handleTouchMove(event) {
            if (event.touches.length !== 2) return;
            
            const touch1 = event.touches[0];
            const touch2 = event.touches[1];
            
            const currentDistance = Math.hypot(
                touch2.clientX - touch1.clientX,
                touch2.clientY - touch1.clientY
            );
            
            if (this.lastTouchDistance) {
                const scaleChange = (currentDistance - this.lastTouchDistance) / 200;
                this.updateScale(this.scale + scaleChange, 
                    (touch1.clientX + touch2.clientX) / 2, 
                    (touch1.clientY + touch2.clientY) / 2);
            }
                
            this.lastTouchDistance = currentDistance;
        },
        // 更新缩放比例
        updateScale(newScale, centerX, centerY) {
            newScale = Math.min(this.maxScale, Math.max(this.minScale, newScale));
            
            const image = this.$refs.image;
            const container = this.$refs.container;
            const imageRect = image.getBoundingClientRect();
            const containerRect = container.getBoundingClientRect();
            
            const offsetX = (centerX - containerRect.left) / this.scale;
            const offsetY = (centerY - containerRect.top) / this.scale;
            
            this.imagePosition.x -= offsetX * (newScale - this.scale);
            this.imagePosition.y -= offsetY * (newScale - this.scale);
            
            this.scale = newScale;
            
            const scaledWidth = imageRect.width * (newScale / this.scale);
            const scaledHeight = imageRect.height * (newScale / this.scale);
            
            this.imagePosition.x = Math.min(0, Math.max(this.imagePosition.x, containerRect.width - scaledWidth));
            this.imagePosition.y = Math.min(0, Math.max(this.imagePosition.y, containerRect.height - scaledHeight));
        },
        //上传图片
        uploadFile(event){
            if(!this.uploadFlag){
                var file = event.target.files[0]
                if(file.size>6*1024*1024){
                    showMessage('The uploaded file cannot exceed 6M','error')
                    this.$refs.fileInput.value = "";
                    return;
                }else{
                    var that = this
                    this.uploadFlag=false
                    //this.compressImage(event)
                    const reader = new FileReader();
                    reader.onload = function(e) {
                        that.uploadImg = e.target.result; // 将图片的 base64 数据设为 img 的 src
                        that.$refs.fileInput.value = "";
                    };
                    reader.readAsDataURL(file); // 读取文件数据为 Data URL
                }
            }
        },
        saveCanvas() {
            if (this.isSaving) return;
            showMessage('Downloading, please wait. . .','success')
            setTimeout(() => {
                this.isSaving = true;
                html2canvas(this.$refs.canvasContainer, {
                    backgroundColor: null,
                    useCORS: true,
                    allowTaint: false
                })
                .then((canvas) => {
                    const link = document.createElement("a");
                    link.download ="your_moment_with_OXVA.png";
                    link.href = canvas.toDataURL("image/png");
                    link.click();
                    this.isSaving = false;
                })
                .catch((err) => {
                    alert("Save failed:" + err.message);
                    this.isSaving = false;
                });
            }, 100);
        }, 
        showPopup(type){
            if(!this.checkLogin()) return;
            this.popup = this[type] = true;
        },
        checkLogin(){
            if(!this.isLogin){
                this.popup = this.loginPopup = true;
                return false;
            }
            return true;
            // showMessage('The event has ended, thank you for your participation','success');
            // return false
        },
        emailUpdate(){
            if(this.isSend){
                this.isSend = false
                this.sendFlag = false
                this.sendText = 'Send code'
            }
        },
        // 工具类-------------------------------------------------
        copyCode(text){
            // 复制指定文案到剪贴板
            navigator.clipboard.writeText(text).then(() => {
                showMessage('Copied successfully','success')
            }).catch(err => {
                showMessage('Copied failed','error')
            });
        },
        downloadImg() {
            if (this.isSaving) return;
            showMessage('Downloading, please wait. . .','success')
            this.isSaving = true;
            
            setTimeout(() => {
                const element = $('.bpc_canvas')[0]; // 要保存的DOM元素
                
                // 使用html2canvas并启用useCORS和allowTaint选项
                html2canvas(element, { 
                    useCORS: true,      // 允许跨域图片
                    allowTaint: false,   // 禁止 taint 跨域图片
                    scale: 3             // 提升清晰度
                }).then(canvas => {
                    // 将canvas转换为图片数据URL
                    const imgData = canvas.toDataURL('image/png');
                    
                    // 创建一个下载链接
                    const link = document.createElement('a');
                    link.href = imgData;
                    link.download = 'Chill-Mate_Combo.png'; // 设置文件名
                    link.click(); // 触发下载
                    this.isSaving = false;
                });
            }, 100);
        },
        QuickFind(){
                var countryList = this.$refs.countryList; // 获取 .country_option 元素
                // 找到第一个以输入字母开头的国家元素
                var targetCountry = Array.from(countryList.children).find((country) =>
                    country.textContent.trim().toLowerCase().startsWith(this.findText.toLowerCase())
            );
            
            if (targetCountry) {
                // 滚动到目标国家
                targetCountry.scrollIntoView({ block: 'start' });
            }
        },
        // cookie
        setCookie(name,value,day){
            var d = new Date();
            d.setTime(d.getTime() + (day * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = name + "=" + value + ";" + expires + ";path=/";
        },
        getCookie(name){
            var name = name + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var cookieArray = decodedCookie.split(';');
            for(let i = 0; i < cookieArray.length; i++) {
                let cookie = cookieArray[i];
                while (cookie.charAt(0) == ' ') {
                    cookie = cookie.substring(1);
                }
                if (cookie.indexOf(name) == 0) {
                    return cookie.substring(name.length, cookie.length);
                }
            }
            return "";
        },
        // 活动倒计时
        startTime() {
            this.updateCountdown();
            this.allInterval = setInterval(this.updateCountdown, 1000);
        },        
        updateCountdown() {
            const now = Date.now();
            const diff = Math.max(0, this.targetTime - now);
        
            // 到点清零并停表
            if (diff === 0) {
              this.countdown.days = "00";
              this.countdown.hours = "00";
              this.countdown.minutes = "00";
              this.countdown.seconds = "00";
              if (this.allInterval) clearInterval(this.allInterval);
              return;
            }
        
            const seconds = Math.floor(diff / 1000) % 60;
            const minutes = Math.floor(diff / (1000 * 60)) % 60;
            const hours   = Math.floor(diff / (1000 * 60 * 60)) % 24;
            const days    = Math.floor(diff / (1000 * 60 * 60 * 24));
        
            const pad = n => String(n).padStart(2, "0");
        
            // 为了避免把整个对象替换（若它是只读或做了冻结），逐项赋值
            this.countdown.days    = pad(days);
            this.countdown.hours   = pad(hours);
            this.countdown.minutes = pad(minutes);
            this.countdown.seconds = pad(seconds);
          }
    },
    created(){
        // 加载完成后 更新弹窗显示样式
        this.loadFlag = true
        //判断登录状态
        if(this.getCookie('_oxva_6th')){
            this.isLogin = true
            this.user.token = this.getCookie('_oxva_6th')
            //获取用户信息
            //this.getInfo()
        }
        //this.startTime();
        
        //this.getCountry()
        //this.getPosts()
    },
    mounted(){
        
        window.addEventListener("wheel", this.handleWheel,{ passive: false });
        
        var wFlag=true
        if(window.innerWidth<750){
            wFlag=false
        }
        
        function showUp(dom){
            gsap.from(dom,{
                y:'2rem',opacity:0,ease:'none',duration:0.5,
                scrollTrigger:{
                    trigger:dom,
                    start:'top bottom-=20%',
                    end:'+=0',
                    toggleActions:'play none none reverse',
                }
            })
        }
        
        setTimeout(() => {
            $('.box1_icon').addClass('box1_show')
            $('.box1_title').addClass('showup')
        }, 300);
        
        //box2
        ScrollTrigger.create({
            trigger:'.box2',
            start:wFlag?'top+=3% top':'top top+=6%',
            end:'+=80%',
            scrub:1,
            animation:gsap.timeline()
            .to('.box2_item div:nth-child(1) span',{y:'-10rem',opacity:0,stagger:0.2})
            .from('.box2_item div:nth-child(2) span',{y:'10rem',stagger:0.2},'-=99%')
            .to({},{duration:0.2})
            .to('.box2_item div:nth-child(2) span',{y:'-10rem',opacity:0,stagger:0.2})
            .from('.box2_item div:nth-child(3) span',{y:'10rem',stagger:0.2},'-=99%')
            .to({},{duration:0.2})
            .to('.box2_item div:nth-child(3) span',{y:'-10rem',opacity:0,stagger:0.2})
            .from('.box2_item div:nth-child(4) span',{y:'10rem',stagger:0.2},'-=99%')
            .to({},{duration:0.2})
            .to('.box2_item div:nth-child(4) span',{y:'-10rem',opacity:0,stagger:0.2})
            .from('.box2_item div:nth-child(5) span',{y:'10rem',stagger:0.2},'-=99%')
            .to({},{duration:0.2})
            .to('.box2_item div:nth-child(5) span',{y:'-10rem',opacity:0,stagger:0.2})
            .from('.box2_item div:nth-child(6) span',{y:'10rem',stagger:0.2},'-=99%')
            .to({},{duration:0.2})
            .to('.box2_item div:nth-child(6) span',{y:'-10rem',opacity:0,stagger:0.2})
            .from('.box2_item div:nth-child(7) span',{y:'10rem',stagger:0.2},'-=99%')
        })
        
        var box2Flag = true
        var $video = $('.box2 video');
        ScrollTrigger.create({
            trigger:'.box2',
            start:wFlag?'top+=3% top':'top top+=6%',
            end:'+=80%',
            scrub:1,
            animation:gsap.timeline().to('.hole_box',{scale:wFlag?3:4}),
            onUpdate: function (self) {
                if(wFlag){
                    $video[0].currentTime = self.progress * 1.033;
                }else{
                    if(box2Flag){
                        $('.box2 video')[0].play()
                        box2Flag = false
                    }
                }
                //console.log($video[0].duration)
            }
        })
        
        ScrollTrigger.create({
            trigger:'.box2',
            start:wFlag?'top+=93% top':'top+=160% top+=6%',
            end:'+=10%',
            scrub:1,
            animation:gsap.timeline()
            .to('.box2 video',{filter: 'brightness(0.3)'})
            .to('.box2_item',{opacity:0},'<')
            .from('.box2_text',{opacity:0}),
        })
        
        ScrollTrigger.create({
            trigger:'.box2',
            start:wFlag?'top+=3% top':'top top+=6%',
            end:wFlag?'+=120%':'+=150%',
            pin:true
        })
        
        //box3
        if(wFlag){
            ScrollTrigger.create({
                trigger:'.box3',
                start:'top top+=20%',
                end:'+=0%',
                //scrub:1,
                //toggleActions:'play none none reverse',
                animation:gsap.timeline()
                .to('.box3_bg img',{x:0,scale:1,ease:'none',duration:0.5})
                .to('.box3_item',{rotateX:0,ease:'none',duration:0.3})
                .from('.box3_title1',{y:'2rem',opacity:0})
            })

            ScrollTrigger.create({
                trigger:'.box3',
                start:'top top+=6%',
                end:'+=30%',
                pin:true,
            })
        }else{
            ScrollTrigger.create({
                trigger:'.box3',
                start:'top center',
                end:'+=0%',
                //toggleActions:'play none none reverse',
                animation:gsap.timeline()
                .to('.box3_bg img',{x:0,scaleY:2,ease:'none',duration:0.5})
                .to('.box3_item',{rotateX:0,ease:'none',duration:0.3})
                .from('.box3_title1',{y:'2rem',opacity:0})
            })
        }
        
        ScrollTrigger.create({
            trigger:'.box3',
            start:wFlag?'top+=45% top':'bottom bottom-=10%',
            end:'+=0%',
            toggleActions:'play none none reverse',
            animation:gsap.timeline()
            .from('.box3_img',{x:'-125%'})
        })
        
        showUp('.box3_title')
        if(!wFlag){
            showUp('.box3_rule')
        }
        ScrollTrigger.create({
            trigger:'.box3',
            start:wFlag?'top+=50% top':'top+=30% top',
            end:wFlag?'+=80%':'+=60%',
            pin:wFlag,
            onUpdate: function (self) {
                let index = Math.floor(self.progress * 100);
                for(let i=1;i<4;i++){
                    if(index>(i-1)*40){
                        $('.box3_rule div').eq(i-1).addClass('box3_active').siblings().removeClass('box3_active')
                    }
                }
            }
        })
        
        //box4
        showUp('.box4_title')
        ScrollTrigger.create({
            trigger:'.box4',
            start:'top top+=40%',
            end:'+=0%',
            toggleActions:'play none none none',
            animation:gsap.timeline()
            .from('.box4_img',{scale:0})
            .from('.box4_progress',{opacity:0})
            .from('.box4_progress1 div',{opacity:0,stagger: { amount: 0.5 }})
            .to('.box4_move',{x:wFlag?'83rem':'20rem',duration:1},'<')
            .to('.box4_move',{opacity:0},'-=5%')
            .to('.box4_progress1',{opacity:0})
            .to('.box4_progress',{opacity:1},'<')
        })
        showUp('.box4_start')
        
        //box5
        if(!wFlag){
            new Swiper('.box5Swiper', {
                slidesPerView: 1.25,
                centeredSlides: true,
                effect: 'cards',
                autoplay:true,
            })
        }
    }
})